/**
 * Navbar
 */

(function ($) {
    "use strict";

    $(document).ready(function () {
        $(".search-box").on('click', 'i', function () {
            $("body").toggleClass("header-search-open");
        });
    });

    // function getCookie(name) {
    //     var regexp = new RegExp("(?:^" + name + "|;\s*" + name + ")=(.*?)(?:;|$)", "g");
    //     var result = regexp.exec(document.cookie);
    //     return (result === null) ? null : result[1];
    // }

    // if (typeof $.cookie('_icl_current_language') === 'undefined') {
    //     showModal();
    // }

})(jQuery);
